/* Library */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { asyncConnect } from 'redux-connect';

// import actions
import * as labelsActions from '../../../../components/labels/actions';
import * as typeActions from './../SelectTypeCelebration/actions';
import * as createEventObject from '../../../createEvent/actions';
import ApplyCSS from '../../../../components/ApplyCSS';
import AppEvents from '../../../App/AppEvents';
import { eventCategory } from '../../../../utils/clientConstant';

// import utils
import commonUtil from '../../../../utils/commonUtil';

// import components
import InputButton from '../../../../components/ZUILib/InputButton';
import serverClientUtil from '../../../../utils/serverClientUtil';

const constChannel = commonUtil.getClientConstForChannel();
const { isLablesLoaded, loadLables } = labelsActions;
const { CheckEventCreateValid } = typeActions;
const channel = commonUtil.getChannel();
const pageName = 'selectWhichMesaTableChoice';
const applicationRoutes = commonUtil.getApplicationRoutes();

@asyncConnect([{
  promise: ({ store: { dispatch, getState } }) => {
    if (!isLablesLoaded(getState())) {
      return dispatch(loadLables());
    }
    return undefined;
  },
},
])
@connect(store => ({
  lables: store.labels.data,
  error: store.labels.error,
  loading: store.labels.loading,
  extraData: store.labels.extraData,
  eventCategoryType: store.eventcategory.data,
  createEventObject: store.createEventObject.data,
  user: store.user.data,
  eventDetail: store.eventDetail.data,
}),
  { ...labelsActions, ...createEventObject })

class SelectWhichMesa extends Component {
  constructor(props) {
    super(props);
    this.handleCreateEventClick = this.handleCreateEventClick.bind(this);
    this.handleBackClick = this.handleBackClick.bind(this);
  }

  static propTypes = {
    lables: PropTypes.object,
  };
  componentWillUnmount() {
    if (channel === constChannel.WAP) {
      AppEvents.unsubscribe(this.wapBackButtonEvent);
    }
  }
  handleBackClick = () => {
    browserHistory.push(applicationRoutes.multipleEvents);
  }
  componentDidMount() {
    if (channel === constChannel.WAP) {
      this.wapBackButtonEvent = AppEvents.subscribe(AppEvents.EVENT_REGISTER.WAP_BACK_BUTTON_CLICKED);
      AppEvents.publish(this.wapBackButtonEvent, [this.handleBackClick]);
    }
  }
  handleLoginWithAuth0 = () => {
    const url = serverClientUtil.getLPFullURL();
    const redirectUrl = 'https:' + url + '/login';
    const redirectBackUrl = `${window.location.origin}/crearevento/seleccioneeltipodemesa`;
    window.location.replace(`${redirectUrl}?redirectAfterLoginHref=${redirectBackUrl}&originalRedirectHref=${window.location.origin}`);
  }
  handleCreateEventClick = () => {
    const selectedEventConfiguration = this.props.location.state;
    const profileId = (this.props.user && this.props.user.result && this.props.user.result.profileId) ? this.props.user.result.profileId : 0;

    if (profileId) {
      if (selectedEventConfiguration === null) {
        browserHistory.push(applicationRoutes.mesaType);
      } else {
        const eventDetail = this.props.eventCategoryType && this.props.eventCategoryType.eventConfigurations ?
          this.props.eventCategoryType.eventConfigurations.filter(item => item.name === selectedEventConfiguration.name)[0] : null;
        CheckEventCreateValid(selectedEventConfiguration.name, profileId).then((response) => {
          if (response.body.status.status === 'success') {
            this.handleNavigateonSuccess(selectedEventConfiguration);
          } else if (response.body.status.status === 'failure') {
            const redirectPath = eventDetail.eventCategory === eventCategory.CELEBRATION ? applicationRoutes.celebrationType : applicationRoutes.openType;
            browserHistory.push({ pathname: redirectPath, state: { error: response.body.status.errorMessage } });
          }
        }).catch((e) => { console.log(e); }); // console required
      }
    } else {
      this.handleNavigateonSuccess(selectedEventConfiguration);
    }
  }

  handleNavigateonSuccess = (selectedEventConfiguration) => {
    if (this.props.user && this.props.user.result && this.props.user.result.profileId) {
      browserHistory.push({ pathname: selectedEventConfiguration.url, state: selectedEventConfiguration });
    } else {
      this.handleLoginWithAuth0();
    }
  }

  handleEnterMyTableClick = () => {
    if (this.props && this.props.eventDetail && this.props.eventDetail.eventList.length > 1) {
      browserHistory.push({ pathname: applicationRoutes.multipleEvents, state: { event: this.props.user.result.eventDetails } });
    } else if (this.props && this.props.eventDetail && this.props.eventDetail.eventList.length === 1) {
      const eventId = this.props.eventDetail.eventList[0].eventId;
      browserHistory.push(commonUtil.routeTo(applicationRoutes.giftList, { eventID: eventId }));
    }
  }

  render() {
    const { lables } = this.props;

    const firstName = this.props && this.props.user && this.props.user.result && this.props.user.result.firstName;

    const createEventButton = {
      type: 'button',
      value: 'Crear Mesa de Regalos',
      style: channel === 'wap' ? 'btnPrimary size-Full' : 'btnPrimary size-ExtraLarge',
      onClickHandler: this.handleCreateEventClick,
    };
    const eventListButton = {
      type: 'button',
      value: 'Entrar a mi Mesa de Regalos',
      style: channel === 'wap' ? 'btnSecondary  size-Full' : 'btnSecondary  size-ExtraLarge',
      onClickHandler: this.handleEnterMyTableClick,
    };

    return (<React.Fragment>
      <ApplyCSS pageName={pageName} />
      <div className="contentBox" id="whichMesa">
        <div className="row">
          <div className="col-xs-12">
            <div className="registerTitles">
              <h2 className={channel === 'wap' ? 'subtitleSection' : 'titleModule'}>{firstName}, {commonUtil.getLabel(lables.eventList, 'eventList.selectWhichMesa.title')}</h2>
              <h2 className="subtitleModule">Hemos detectado que ya cuentas con una mesa de regalos, ¿Deseas hacer una nueva o entrar a tu mesa?</h2>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6 buttonBlock">
            <InputButton buttonAttr={createEventButton} />
          </div>
          <div className="col-sm-6 buttonBlock">
            <InputButton buttonAttr={eventListButton} />
          </div>
        </div>
      </div>
    </React.Fragment>

    );
  }
}
const mapStateToProps = state => ({
  lables: state.labels.data,
});

export default connect(mapStateToProps)(SelectWhichMesa);
